import moment from "moment"
import translations from "translations"
import * as I18n from "services/i18n"

export function handleFormValidations() {
  $(document).on('change', '#reports-generator-all-period', function() {
    if($(this).is(':checked')) {
      $('.date input').val('')
      $('.p-error').hide()
    }
  })

  $(document).on('click', '#reports-generator-form .btn-search', function(event) {
    const allPeriodUnchecked = !$('#reports-generator-all-period').is(':checked')
    const beginAt = moment($('input[name="request[begin_at]"]').val(), "DD/MM/YYYY")
    const endAt = moment($('input[name="request[end_at]"]').val(), "DD/MM/YYYY")
    const invalidDates = beginAt > endAt

    $('.p-error').text('')

    if(allPeriodUnchecked && (!beginAt.isValid() || !endAt.isValid())) {
      preventDefaultAndScrollTop(event)

      $('.p-error').text(I18n.t(translations(), 'errors.messages.blank')).show()
    } else if(invalidDates){
      preventDefaultAndScrollTop(event)

      $('.begin-at.p-error').text(I18n.t(translations(), 'reports_generator.form.errors.invalid_dates')).show()
    } else {
      $('.p-error').hide()
    }
  })
}

function preventDefaultAndScrollTop(event) {
  $("html, body").animate({ scrollTop: 0 });
  event.preventDefault()
}
